import { login, get_scan_status, getPhoneCode, smsLogin, logout, getEmailCode, emailLogin } from '@/api/common'
import config from '@yld/yun-utils-host'
import Utils from '@yld/yun-utils-common'

const cookieKey = config.BASE_URL.PREFIX_DOT + 'user'

const getDefaultState = () => {
  return {
    token: Utils.Cookie.getCookie(cookieKey, { domain: config.BASE_URL.DOMAIN_URL })
  }
}

const state = getDefaultState()

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, loginPlatform } = userInfo
    return new Promise((resolve, reject) => {
      login({ name: username.trim(), pwd: password, loginPlatform }).then(response => {
        const { data } = response
        if (data !== null) {
          var tokenValue = data.xuser.toString() + ',' + data.tenantId
          commit('SET_TOKEN', tokenValue)
          Utils.Cookie.setCookie(cookieKey, { value: tokenValue,
            domain: config.BASE_URL.DOMAIN_URL,
            expires: 10080 }) // cookie保存一天
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getScanStatus({ commit }, info) {
    return new Promise((resolve, reject) => {
      get_scan_status(info).then(response => {
        const { data } = response
        if (data !== null && data.status === 1 && data.info !== null) {
          var tokenValue = data.info.xuser.toString() + ',' + data.info.tenantId
          commit('SET_TOKEN', tokenValue)
          Utils.Cookie.setCookie(cookieKey, { value: tokenValue,
            domain: config.BASE_URL.DOMAIN_URL,
            expires: 10080 }) // cookie保存7天
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 验证滑块并获取手机验证码
  getPhoneCode({ commit }, data) {
    return getPhoneCode(data)
  },
  // 手机验证码登录
  smsLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      smsLogin(data).then(response => {
        const { data } = response
        if (data !== null) {
          var tokenValue = data.xuser.toString() + ',' + data.tenantId
          commit('SET_TOKEN', tokenValue)
          Utils.Cookie.setCookie(cookieKey, { value: tokenValue,
            domain: config.BASE_URL.DOMAIN_URL,
            expires: 10080 }) // cookie保存一天
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 验证滑块并获取邮箱验证码
  getEmailCode({ commit }, data) {
    return getEmailCode(data)
  },
  // 邮箱验证码登录
  emailLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      emailLogin(data).then(response => {
        const { data } = response
        if (data !== null) {
          var tokenValue = data.xuser.toString() + ',' + data.tenantId
          commit('SET_TOKEN', tokenValue)
          Utils.Cookie.setCookie(cookieKey, { value: tokenValue,
            domain: config.BASE_URL.DOMAIN_URL,
            expires: 10080 }) // cookie保存一天
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

